import { Box } from '@mui/material';
import { observer, useLocalObservable } from 'mobx-react-lite'
import { useEffect } from 'react'
import CardView from '../../component/card/card-view';
import { Reseller } from '../../models';
import i18n from '../../i18n';
import { MobxObjectsManager, useManualRemove } from '../mobx-objs/mobx-manager';
import ButtonComponent from '../../component/button/button.component';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { TopBarState } from '../../component/top-bar/top-bar-state';
import ResellerAccount from './reseller-account.page';
import { ResellerUnitData } from './reseller-unit-data';
import { ResellerAccountState } from './reseller-account-state';
import _ from 'lodash';

export const resellerUnitData = MobxObjectsManager.get(ResellerUnitData);
const ResellerUnit = observer(({ reseller, goBack }: { reseller: Reseller, goBack: () => void }) => {
    const topBarState = MobxObjectsManager.get(TopBarState);
    useEffect(() => {
        MobxObjectsManager.get(ResellerUnitData, reseller);
    });
    useEffect(() => {
        topBarState.updateResellerTitle(_.get(reseller, 'nickname', ''));
    }, [topBarState, _.get(reseller, 'nickname', '')]);
    useManualRemove(ResellerUnitData);
    return (
        <div className='reseller-management-page reseller-unit'>
            <Box className='FC' marginBottom={'1rem'} >
                <ButtonComponent
                    {...{
                        variant: 'contained',
                        size: 'small',
                        extraButtonStyle: 'return-button',
                        extraTitleStyle: 'return-button-icon',
                        titleText: `${i18n.t('general_button_go_back')}`,
                        // 返回集团管理列表
                        handleClick: () => { goBack(); topBarState.updateResellerTitle(''); },
                        children: <ChevronLeftIcon />
                    }}
                />
            </Box>
            <CardView
                contentRender={<PanelFilter reseller={reseller} />}
            />
        </div>
    )
})

const PanelFilter = observer((props: { reseller: Reseller }) => {
    const { reseller } = props;
    // 经销商账号数据管理
    const useAccountData = useLocalObservable(() => new ResellerAccountState({
        belongedResellerId: reseller._id,
    }));
    return (
        <ResellerAccount
            componentSource='ADMIN_RESELLER_DETAIL'
            useResellerAccountMobx={useAccountData}
        />
    )
})

export default ResellerUnit;